<template>
    <div class="footer-container">
        <span class="footer-text-left">
            Archívum
        </span>
        <span class="footer-text-right">
            {{ userName }}
        </span>
    </div>
</template>

<script>
export default {


    created() {
        const nHash = [];
        for (let i = 0; i <= 7; i++) {
            nHash.push(this.$simbIHC.rdH);
        }
        this.noise = nHash;
    },
    data() {
        return {
            noise: []
        }
    },
    computed: {
        userName() {
            return this.$store.state.user_module.userName;
        },
        hash() {
            return this.$simbIHC.rHS
        }
    },
}
</script>

<style lang="scss" scoped>
    .footer-container {
        width: 100%;        
    }

    .footer-text-left {
        float: left;
    }

    .footer-text-right {
        float: right;
    }
</style>
